import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { getCmsContent } from '../api/cms/cms-content.service'

// Initialize i18n
i18n.use(initReactI18next).init({
  resources: {},
  lng: 'en',
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
})

// Define the list of translation namespaces
const staticNamespaces = [
  'cookie',
  'validation',
  'form',
  'app',
  'error',
  'data',
  'summary',
  'contact',
  'completion',
  'link-expired',
  'authenticate',
  'upload',
] as const

const cmsNamespaces = ['footer', 'links'] as const

// Type for namespaces (literal union)
type StaticNamespace = (typeof staticNamespaces)[number]
type CmsNamespace = (typeof cmsNamespaces)[number]

// Type for the dynamic JSON imports
type TranslationModule = {
  default: Record<string, unknown>
}

export default async function loadTranslations(
  brandName: string
): Promise<void> {
  // Load static translations
  const staticTranslationsPromise = Promise.all(
    staticNamespaces.map(async (item: StaticNamespace) => {
      try {
        const baseModule: TranslationModule = await import(
          `../../resources/base/content/${item}.json`
        )
        i18n.addResourceBundle('en', item, baseModule.default, true, true)

        try {
          const brandModule: TranslationModule = await import(
            `../../resources/${brandName}/content/${item}.json`
          )
          i18n.addResourceBundle('en', item, brandModule.default, true, true)
        } catch {
          // No brand-specific file found, ignore
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(
          `Failed to load translation for namespace: ${item}`,
          error
        )
      }
    })
  )

  // Load CMS translations
  const cmsTranslationsPromise = getCmsContent(brandName)
    .then((cmsData) => {
      cmsNamespaces.forEach((namespace: CmsNamespace) => {
        if (cmsData[namespace]) {
          i18n.addResourceBundle(
            'en',
            namespace,
            cmsData[namespace],
            true,
            true
          )
        }
      })
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Failed to load CMS translations:', error)
    })

  await Promise.all([staticTranslationsPromise, cmsTranslationsPromise])
}
